import type { HrefParts } from '../models/site.model';

export function splitHref(href: string): HrefParts {
  const [beforeHash, fragment] = href.split('#');
  const [path, search] = beforeHash.split('?');
  const query: Record<string, string> = {};
  if (search) {
    for (const pair of search.split('&')) {
      const [key, value] = pair.split('=');
      if (key) query[key] = decodeURIComponent(value ?? '');
    }
  }
  return { path: path || '/', fragment, query };
}
